<div class="modal-header">
  <h4 class="modal-title">{{'menuitem.device-settings' | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <app-device-setting-form #formComponent></app-device-setting-form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>
  <!-- <button type="button" class="btn btn-outline-primary" (click)="openPrinterSetting()">
    <i class="fa fas fa-print" aria-hidden="true"></i>
    {{'menuitem.printer' | translate}}
  </button> -->

  <button type="button" class="btn btn-primary" (click)="save()">
    {{'button.save' | translate}}
  </button>
</div>